import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCommunityFollowMainRequest,
  fetchCommunityTrendMainRequest,
  fetchCommunityVideoMainRequest,
  fetchFavoritesMainRequest,
  fetchHistoryMainRequest,
  fetchRandomRecipeRequest,
  fetchSuggestionByTypeRequest,
  fetchUserSuggestionRequest,
  fetchWeatherMainRequest,
  reloadUserSuggestionRequest,
  RemoveFavoritesMain,
} from "../store/actions";
import { capitalizeFirstLetter } from "core/utils/helper";
import { IDSuggestion } from "../type";
import API from "core/networks/API";
import { API_SUGGESTION_BY_TYPE } from "../api";

export const useRandomRecipe = (params?: any) => {
  const dispatch = useDispatch();
  const list = useSelector((state: any) => state.Main.random_recipes);
  useEffect(() => {
    if (params) {
      dispatch(fetchRandomRecipeRequest(params));
    }
  }, [dispatch, params]);

  return [list.data, list.loadingRandomRecipes];
};

export const useSuggestionByType = (params?: any) => {
  const dispatch = useDispatch();
  const list: any = useSelector((state: any) => state.Main.suggestion_by_type);

  useEffect(() => {
    if (params) {
      dispatch(
        fetchSuggestionByTypeRequest({
          ...params,
          id: IDSuggestion[params.type],
        })
      );
    }
  }, [dispatch, params?.refresh, params?.type]);

  return [
    list[params.type],
    list[`loading${capitalizeFirstLetter(params.type)}`],
  ];
};

export const useFavoritesMain = (params?: any) => {
  const user = useSelector((state: any) => state.Auth.userInfo);
  const dispatch = useDispatch();

  const list = useSelector((state: any) => state.Main.favorites_main);
  const _params = {
    page: 0,
    page_size: 0,
    order_by: "updated_at",
    order_dir: "desc",
    relation: "userRecipeFavorite",
    ...params,
  };
  useEffect(() => {
    if (params && user?.id) {
      dispatch(fetchFavoritesMainRequest(_params));
    }
  }, [params, user]);

  return [list.data, list.loading];
};

export const useWeatherMain = (params?: any) => {
  const dispatch = useDispatch();

  const list = useSelector((state: any) => state.Main.weather_main);
  const title = list?.data?.title;
  const _params = {
    refresh: params?.refresh,
  };
  useEffect(() => {
    dispatch(fetchWeatherMainRequest({ ..._params }));
  }, [params.refresh]);

  return [list?.data?.data || [], title, list.loadingWeatherMain];
};

export const useHistoryMain = (params?: any) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: any) => state.Auth.userInfo);
  const list = useSelector((state: any) => state.Main.history_main);
  console.log("list", list);

  const _params = {
    refresh: params?.refresh,
    page_size: 10,
    page: 1,
    order_by: "created_at",
    order_dir: "desc",
  };
  useEffect(() => {
    if (userInfo?.id) {
      dispatch(fetchHistoryMainRequest({ ..._params }));
    }
  }, [params.refresh]);

  return [list?.data?.data || [], list.loadingHistoryMain];
};

export const useRemoveFavoriteById = () => {
  const dispatch = useDispatch();
  const handleRemove = (id: number) => {
    dispatch(RemoveFavoritesMain({ id }));
  };

  return handleRemove;
};

export const useGetIdSuggestion = (cb: any) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDetail = async (data: any) => {
    try {
      setLoading(true);
      const res: any = await API.post(API_SUGGESTION_BY_TYPE, data);
      console.log(res);
      cb.onSuccess(res.data);
    } catch (error: any) {
      setLoading(false);
      cb.onFailed(error);
    }
  };

  return [loading, handleDetail];
};

export const useCommunityTrendMain = (params?: any) => {
  const dispatch = useDispatch();

  const list = useSelector((state: any) => state.Main.community_trend_main);
  const _params = {
    refresh: params?.refresh,
    limit: 10,
    order_by: "created_at",
    order_dir: "desc",
    ...params,
  };
  useEffect(() => {
    dispatch(fetchCommunityTrendMainRequest({ ..._params }));
  }, [params.refresh, params.tab]);

  return [list?.data?.data || [], list.loadingCommunityTrendMain];
};

export const useCommunityFollowMain = (params?: any) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: any) => state.Auth.userInfo);
  const list = useSelector((state: any) => state.Main.community_follow_main);
  const _params = {
    refresh: params?.refresh,
    page_size: 10,
    page: 1,
    order_by: "created_at",
    order_dir: "desc",
    ...params,
  };
  useEffect(() => {
    if (userInfo?.id) {
      dispatch(fetchCommunityFollowMainRequest({ ..._params }));
    }
  }, [params.refresh, params.tab, userInfo?.id]);

  return [list?.data?.data || [], list.loadingCommunityFollowMain];
};

export const useCommunityVideoMain = (params?: any) => {
  const dispatch = useDispatch();

  const list = useSelector((state: any) => state.Main.community_video_main);
  const _params = {
    refresh: params?.refresh,
    page_size: 10,
    page: 1,
    order_by: "created_at",
    order_dir: "desc",
    ...params,
  };
  useEffect(() => {
    dispatch(fetchCommunityVideoMainRequest({ ..._params }));
  }, [params.refresh, params.tab]);

  return [list?.data?.data || [], list.loadingCommunityVideoMain];
};

export const useUserSuggestionMain = (params?: any) => {
  const dispatch = useDispatch();
  
  const list = useSelector((state: any) => state.Main.user_suggestion_main);
  const title = list?.data?.title;
  const _params = {
    refresh: params?.refresh,
  };
  useEffect(() => {
    dispatch(fetchUserSuggestionRequest({..._params}));
  }, [params.refresh]);

  const reload = () => {
    dispatch(reloadUserSuggestionRequest({..._params}));
  }

  return {
    userSuggestions:list?.data?.data || [],
    title,
    loading:list.loadingUserSuggestionMain,
    reload
  };
};
